import styled from "@emotion/styled";
import { Button as F7Button, f7, Link, Toolbar as F7Toolbar, View, Views } from "framework7-react";
import { MouseEvent, useCallback, useRef } from "react";

import { useConfig } from "@/hooks/useConfig";
import { useRefetchQueries } from "@/hooks/useRefetchQueries";
import { useDimensionStore } from "@/stores/dimensionStore";

const Button = styled(F7Button)`
  height: 50px;
  width: 60px;
`;

const Toolbar = styled(F7Toolbar)`
  .toolbar-inner {
    display: grid;
    grid-template-columns: 1fr 1fr 0.8fr 1fr 1fr;
  }
`;

export function AppLayout() {
  useConfig();

  useRefetchQueries();

  const { resetDimensionType } = useDimensionStore();

  const lastActiveTabIdRef = useRef("");

  const handleTabLinkClick = useCallback(
    (event: MouseEvent<HTMLAnchorElement>) => {
      const target = event.target as HTMLElement;
      const tabLink = target.closest<HTMLAnchorElement>(".tab-link");

      if (!tabLink) return;

      const tabId = tabLink.id;
      const tabName = tabLink.dataset.tab;
      const tabUrl = tabLink.dataset.tabUrl;

      if (!tabId || !tabName || !tabUrl) return;

      if (lastActiveTabIdRef.current === tabId) {
        const view = f7.views.get(tabName);
        if (view) {
          if (view.router.currentRoute.url !== tabUrl) {
            view.router.navigate(tabUrl);
            resetDimensionType();
          }
        }
      }

      lastActiveTabIdRef.current = tabId;
    },
    [resetDimensionType],
  );

  return (
    <Views tabs>
      <Toolbar
        bottom
        icons
        tabbar
        id="app-layout-bottom-toolbar"
      >
        <Link
          tabLinkActive
          className="no-ripple"
          data-tab-url="/"
          iconIos="f7:house"
          iconMd="material:home"
          id="app-view-home-link"
          tabLink="#view-home"
          text="ホーム"
          onClick={handleTabLinkClick}
        />
        <Link
          className="no-ripple"
          data-tab-url="/review/"
          iconIos="f7:square_list_fill"
          iconMd="material:schedule"
          id="app-view-review-link"
          tabLink="#view-review"
          text="振り返り"
          onClick={handleTabLinkClick}
        />
        <Button
          fill
          round
          color="primary"
          href="/modals/activity-launcher/"
          iconIos="f7:plus"
          iconMd="material:add"
          id="app-launcher-button"
        />
        <Link
          className="no-ripple"
          data-tab-url="/diary/"
          iconIos="f7:gear"
          iconMd="material:auto_stories"
          id="app-view-diary-link"
          tabLink="#view-diary"
          text="日記"
          onClick={handleTabLinkClick}
        />
        <Link
          className="no-ripple"
          data-tab-url="/settings/"
          iconIos="f7:gear"
          iconMd="material:settings"
          id="app-view-settings-link"
          tabLink="#view-settings"
          text="設定"
          onClick={handleTabLinkClick}
        />
      </Toolbar>

      <View
        main
        tab
        tabActive
        id="view-home"
        url="/"
      />

      <View
        tab
        id="view-review"
        name="review"
        url="/review/"
      />

      <View
        tab
        id="view-diary"
        name="diary"
        url="/diary/"
      />

      <View
        tab
        id="view-settings"
        name="settings"
        url="/settings/"
      />
    </Views>
  );
}
